import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FiPower, FiTrash2, FiPlus } from 'react-icons/fi';
import './AdminPanel.css';
import Navbar from './Navbar';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const BanPage = () => {
  const [banEnabled, setBanEnabled] = useState(true);
  const [vpaAddress, setVpaAddress] = useState('');
  const [bannedVPAs, setBannedVPAs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [authChecked, setAuthChecked] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const navigate = useNavigate();

  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  };

  const checkAuth = async () => {
    try {
      const token = getCookie('offerAdminAuth');
      if (!token) {
        navigate('/adminBT/login');
        return false;
      }

      const res = await axios.post('https://offers.cashbolt.in.net/server/', {
        action: 'checkAuth',
        authToken: token
      });

      if (!res.data.status) {
        navigate('/adminBT/login');
        return false;
      }
      return true;
    } catch (error) {
      navigate('/adminBT/login');
      return false;
    }
  };

  const fetchBanSettings = async () => {
    try {
      const token = getCookie('offerAdminAuth');
      const response = await axios.post('https://offers.cashbolt.in.net/server/', {
        action: 'getVPABanSettings',
        authToken: token
      });

      if (response.data.status) {
        setBanEnabled(response.data.data.banEnabled);
        setBannedVPAs(response.data.data.bannedVPAs || []);
      } else {
        console.error('Failed to fetch VPA ban settings:', response.data.message);
      }
    } catch (error) {
      console.error("Error fetching VPA ban settings:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const verifyAuth = async () => {
      const isAuthenticated = await checkAuth();
      setAuthChecked(isAuthenticated);
      if (isAuthenticated) {
        await fetchBanSettings();
      }
    };
    verifyAuth();
  }, []);

  const isValidVPA = (vpa) => {
    // Basic VPA validation - can be enhanced as needed
    const vpaRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9]+$/;
    return vpaRegex.test(vpa);
  };

  const handleAddVPA = async () => {
    if (!vpaAddress || !isValidVPA(vpaAddress)) {
     // alert('Please enter a valid VPA address (e.g., username@upi)');
      return;
    }

    setIsAdding(true);
    try {
      const token = getCookie('offerAdminAuth');
      const response = await axios.post('https://offers.cashbolt.in.net/server/', {
        action: 'addBannedVPA',
        authToken: token,
        vpa: vpaAddress
      });

      if (response.data.status) {
        setBannedVPAs(response.data.data.bannedVPAs);
        setVpaAddress('');
       // alert('VPA added to ban list successfully!');
      } else {
        console.error('Failed to add VPA:', response.data.message);
        //alert('Failed to add VPA: ' + response.data.message);
      }
    } catch (error) {
      console.error("Error adding VPA:", error);
     // alert('Error adding VPA to ban list');
    } finally {
      setIsAdding(false);
    }
  };

  const handleDeleteVPA = async (id) => {

    setIsDeleting(true);
    try {
      const token = getCookie('offerAdminAuth');
      const response = await axios.post('https://offers.cashbolt.in.net/server/', {
        action: 'removeBannedVPA',
        authToken: token,
        vpaId: id
      });

      if (response.data.status) {
        setBannedVPAs(response.data.data.bannedVPAs);
        //alert('VPA removed from ban list successfully!');
      } else {
        console.error('Failed to remove VPA:', response.data.message);
       // alert('Failed to remove VPA: ' + response.data.message);
      }
    } catch (error) {
      console.error("Error removing VPA:", error);
      //alert('Error removing VPA from ban list');
    } finally {
      setIsDeleting(false);
    }
  };
    const toggleBanStatus = async () => {
        const newStatus = !banEnabled;
        try {
            const token = getCookie('offerAdminAuth');
            const response = await axios.post('https://offers.cashbolt.in.net/server/', {
                action: 'updateVPABanStatus',
                authToken: token,
                status: newStatus
            });

            if (response.data.status) {
                setBanEnabled(newStatus);
              //  alert(`VPA ban feature ${newStatus ? 'enabled' : 'disabled'} successfully!`);
            } else {
                console.error('Failed to update ban status:', response.data.message);
            }
        } catch (error) {
            console.error("Error updating ban status:", error);
            alert('Error updating ban status');
        }
    };

        if (!authChecked || loading) {
        return (
            <div className="admin-loading">
                <div className="loading-spinner"></div>
            </div>
        )
      }
  return (
    <div className="admin-container">
      <Navbar />

      <header className="admin-header">
        <h1>VPA Ban List</h1>
      </header>

      <motion.div
        className="settings-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        {/* Ban List Toggle */}
        <div className="form-group">
          <label>VPA Banning</label>
          <div className="toggle-container">
            <button
              type="button"
              className={`toggle-option ${banEnabled ? 'active' : ''}`}
              onClick={() => toggleBanStatus(true)}
            >
              <FiPower className="toggle-icon" />
              <span>Enabled</span>
            </button>
            <button
              type="button"
              className={`toggle-option ${!banEnabled ? 'active' : ''}`}
              onClick={() => toggleBanStatus(false)}
            >
              <FiPower className="toggle-icon" />
              <span>Disabled</span>
            </button>
          </div>
        </div>

        {/* Add VPA Section */}
        <div className="form-group">
          <label>Add VPA to Ban</label>
          <div className="input-with-button">
            <input
              type="text"
              value={vpaAddress}
              onChange={(e) => setVpaAddress(e.target.value)}
              placeholder="Enter VPA (e.g., username@upi)"
              className="vpa-input"
            />
            <motion.button
              className="add-button"
              onClick={handleAddVPA}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              disabled={!isValidVPA(vpaAddress)}
            >
              <FiPlus className="button-icon" />
              Ban VPA
            </motion.button>
          </div>
          {vpaAddress && !isValidVPA(vpaAddress) && (
            <div className="error-message">Please enter a valid VPA (format: username@bank)</div>
          )}
        </div>

        {/* Banned VPAs Table */}
        <div className="whitelist-table-container">
          <table className="whitelist-table">
            <thead>
              <tr>
                <th>VPA Address</th>
                <th>Banned On</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {bannedVPAs.map((vpa) => (
                <motion.tr
                  key={vpa.id}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.2 }}
                >
                  <td>{vpa.vpa}</td>
                   <td>{vpa.createdAt}</td>
                  <td>
                    <button
                      className="delete-button"
                      onClick={() => handleDeleteVPA(vpa.vpa)}
                    >
                      <FiTrash2 />
                      <span className="button-text">Unban</span>
                    </button>
                  </td>
                </motion.tr>
              ))}
              {bannedVPAs.length === 0 && (
                <tr>
                  <td colSpan="3" className="no-ips-message">
                    No VPAs currently banned
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </motion.div>
    </div>
  );
};

export default BanPage;